import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatCheckboxChange} from '@angular/material/checkbox';

export interface QuestionnairesAvailable {
  message: string;
  values: string[];
}


@Component({
  selector: 'app-questionnaire-add-dialog',
  templateUrl: './questionnaire-add-dialog.html',
  styleUrls: ['./questionnaire-add-dialog.css']
})
export class QuestionnaireAddDialogComponent implements OnInit {

  results = [];

  constructor(public dialogRef: MatDialogRef<QuestionnaireAddDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: QuestionnairesAvailable) { }

  ngOnInit(): void {
  }

  cancel() {
    this.dialogRef.close();
  }

  setResults($event: MatCheckboxChange, value: string) {
    if ($event.checked) {
      this.results.push(value);
    } else {
      this.results.forEach( (r, index) => {
        if (r.localeCompare(value) === 0) {
          this.results.splice(index, 1);
        }
      });
    }
    console.log(this.results);
  }
}
